/**
 * Public subscription catalog. Display amounts are USD.
 * Checkout uses plan.id against the server catalog.
 */
export const SUBSCRIPTION_PLANS = [
  {
    id: 'monthly',
    name: 'ByOnco PRO',
    subtitle: 'For patients and families',
    amount: 19.99,
    compareAt: 39.99,
    currency: 'USD',
    period: '/month',
    description: 'Unlimited oncology companion access. Ask the questions that pile up between appointments.',
    features: [
      'Unlimited questions with Vani',
      'Answers scoped like a careful oncologist, never a diagnosis or a dose',
      'Hospital matching with explainable fit scores',
      'US care packages (Value / Balanced / Comfort estimates)',
      'Treatment cost estimates and insurance framing',
      'Expert written second opinions (target within 12 hours)',
      'Check-ins, bookmarks, and conversation analysis',
      'Remembers your diagnosis, regimen, and city',
    ],
    popular: true,
    serviceType: 'subscription_monthly',
    planType: 'monthly',
  },
  {
    id: 'yearly',
    name: 'ByOnco PRO Yearly',
    subtitle: '25% off the monthly price',
    amount: 179.88,
    compareAt: 239.88,
    currency: 'USD',
    period: '/year',
    description: 'A full year of unlimited companion access.',
    features: [
      'Everything in PRO',
      'Billed once a year',
      'Cancel anytime before renewal',
    ],
    popular: false,
    serviceType: 'subscription_yearly',
    planType: 'yearly',
  },
  {
    id: 'lifetime',
    name: 'Lifetime',
    subtitle: 'One payment. Yours for good.',
    amount: 999,
    compareAt: null,
    currency: 'USD',
    period: ' once',
    description: 'Pay once for companion access for life, for families who know they will need this for years.',
    features: [
      'Everything in PRO, forever',
      'No renewals',
      'Priority when we add new care tools',
    ],
    popular: false,
    serviceType: 'subscription_lifetime',
    planType: 'lifetime',
    badge: 'Best value',
  },
  {
    id: 'byonco-pro',
    name: 'ByOnco Weekly Access',
    subtitle: 'Weekly PRO access',
    amount: 99,
    currency: 'USD',
    period: '/week',
    description: 'Full platform access for 7 days',
    features: [
      'Explainable hospital matching',
      'US care package estimates',
      'Second opinions',
      'Cost estimates',
    ],
    popular: false,
    serviceType: 'subscription_byonco_pro',
    planType: 'weekly',
    hidden: true,
  },
  {
    id: 'hospital-saas',
    name: 'Hospital SaaS',
    subtitle: 'For cancer centers',
    amount: 10000,
    currency: 'USD',
    period: '/month',
    description: 'Enterprise dashboard for qualified international referrals',
    features: [
      'Qualified international patient referrals',
      'Complete case documentation packets',
      'Patient conversion tracking',
    ],
    popular: false,
    serviceType: 'subscription_hospital_saas',
    cta: 'Request Demo',
    hidden: true,
  },
];

export const PUBLIC_PLANS = SUBSCRIPTION_PLANS.filter((plan) => !plan.hidden);

export function getPlanById(planId) {
  return SUBSCRIPTION_PLANS.find((plan) => plan.id === planId);
}

export function getPlanByServiceType(serviceType) {
  return SUBSCRIPTION_PLANS.find((plan) => plan.serviceType === serviceType);
}

export function formatUsd(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
}
